import React from "react";

const ModalFooter = ({ children }) => {
    return <div className="Modal2-footer">{children}</div>;
};
export default ModalFooter;
